export class PlayerEmitter {
    constructor() {
        this.listeners = {
            ended: [],
            error: [],
            pause: [],
            play: [],
            ratechange: [],
            seeked: [],
            timeupdate: [],
            frameupdate: [],
            fullscreenchange: [],
        };
    }
    addEventListener(name, callback) {
        this.listeners[name].push(callback);
    }
    removeEventListener(name, callback) {
        this.listeners[name] = this.listeners[name].filter((l) => l !== callback);
    }
    dispatchEvent(dispatchName, context) {
        this.listeners[dispatchName].forEach((callback) => {
            callback({ detail: context });
        });
    }
    dispatchSeek(frame) {
        this.dispatchEvent('seeked', {
            frame,
        });
    }
    dispatchPause() {
        this.dispatchEvent('pause', undefined);
    }
    dispatchPlay() {
        this.dispatchEvent('play', undefined);
    }
    dispatchEnded() {
        this.dispatchEvent('ended', undefined);
    }
    dispatchRatechange(playbackRate) {
        this.dispatchEvent('ratechange', {
            playbackRate,
        });
    }
    dispatchError(error) {
        this.dispatchEvent('error', {
            error,
        });
    }
    dispatchTimeUpdate(event) {
        this.dispatchEvent('timeupdate', event);
    }
    dispatchFrameUpdate(event) {
        this.dispatchEvent('frameupdate', event);
    }
    dispatchFullscreenChangeUpdate(event) {
        this.dispatchEvent('fullscreenchange', event);
    }
}
export class ThumbnailEmitter {
    constructor() {
        this.listeners = {
            error: [],
        };
    }
    addEventListener(name, callback) {
        this.listeners[name].push(callback);
    }
    removeEventListener(name, callback) {
        this.listeners[name] = this.listeners[name].filter((l) => l !== callback);
    }
    dispatchEvent(dispatchName, context) {
        this.listeners[dispatchName].forEach((callback) => {
            callback({ detail: context });
        });
    }
    dispatchError(error) {
        this.dispatchEvent('error', {
            error,
        });
    }
}
